export const promote_PromoteEvents = [
	{
		icon: '☝️',
		subtitle: 'promotionData_subtitle1',
	},
	{
		icon: '💁‍♀️',
		subtitle: 'promotionData_subtitle2',
	},
];
